export default class PostsManagerInit {
    constructor() {
        const element = document.querySelector(".js-container-posts");

        if (element) {
            import(
                /* webpackChunkName: "PostsManager" */ "../classes/style/PostsManager"
            ).then(res => {
                const PostsManager = res.default;
                new PostsManager(element);
            });
        }
    }
}
